import _ from 'lodash'
import { useMemo } from 'react'
import { HeaderBuilder } from '../../../../globalComponents/Builders'

export default function HeaderBar({
  rfiType,
  manufacturingTypeId,
  rfiObject,
  template,
  refreshRFIScreen,
  isReadonly,
  isNonCompliant,
  setAuditData,
  isUFLPA
}) {
  const headerData = useMemo(() => {
    const sections = template?.fixed_sections?.sections || []
    return {
      rfiHeaderText: sections?.[0]?.section_name,
      infoIconText: sections?.[0]?.info_icon,
      fixedSectionsTemplate: sections,
    }
  }, [template])

  return (
    <HeaderBuilder
      rfiType={_.capitalize(rfiType)}
      manufacturingType={rfiObject?.manufacturing_type}
      manufacturingTypeId={manufacturingTypeId}
      rfiObject={rfiObject?.fixed_sections}
      headerData={headerData}
      supplierId={rfiObject?.supplier_id}
      supplierName={
        rfiType === 'location'
          ? rfiObject?.supplier_name
          : rfiObject?.fixed_sections?.supplier_contact_information
              ?.supplier_name
      }
      locationId={rfiObject?.location_id}
      locationName={
        rfiType === 'location'
          ? rfiObject?.fixed_sections?.factory_contact_information
              ?.location_name
          : ''
      }
      setAuditData={setAuditData}
      vettingStatus={rfiObject?.vetting_status}
      refreshRFIScreen={refreshRFIScreen}
      isReadonly={isReadonly}
      isNonCompliant={isNonCompliant}
      isUFLPA={isUFLPA}
    />
  )
}
